;(function () {
  'use strict'

  angular
    .module('contrast.available-languages')
    .factory('LanguagesService', LanguagesService)

  function LanguagesService(languageApiConfig) {
    'ngInject'

    var languages = {
      JAVA: { name: 'Java', value: 'JAVA', display: 'Java' },
      DOTNET: { name: '.NET', value: 'DOTNET', display: '.NET Framework' },
      DOTNET_CORE: {
        name: '.NET Core',
        value: 'DOTNET_CORE',
        display: '.NET Core'
      },
      NODE: { name: 'Node', value: 'NODE', display: 'Node' },
      RUBY: { name: 'Ruby', value: 'RUBY', display: 'Ruby' },
      PYTHON: { name: 'Python', value: 'PYTHON', display: 'Python' },
      PHP: { name: 'PHP', value: 'PHP', display: 'PHP' },
      PROXY: { name: 'Proxy', value: 'PROXY', display: 'Proxy' },
      GO: { name: 'Go', value: 'GO', display: 'Go' }
    }

    return {
      isNode: isNode,
      isJava: isJava,
      isRuby: isRuby,
      isDotnet: isDotnet,
      isPython: isPython,
      isPHP: isPHP,
      isProxy: isProxy,
      isGo: isGo,
      getLanguage: getLanguage,
      getAllAsArray: getAllAsArray,
      getAllValues: getAllValues,
      loadAgentLanguages: loadAgentLanguages
    }

    function isNode(language) {
      return language === languages.NODE.name
    }

    function isJava(language) {
      return language === languages.JAVA.name
    }

    function isRuby(language) {
      return language === languages.RUBY.name
    }

    function isDotnet(language) {
      return language === languages.DOTNET.name
    }

    function isPython(language) {
      return language === languages.PYTHON.name
    }

    function isPHP(language) {
      return language === languages.PHP.name
    }

    function isProxy(language) {
      return language === languages.PROXY.name
    }

    function isGo(language) {
      return language === languages.GO.name
    }

    function getLanguage(language) {
      return Object.keys(languages)
        .map(function (key) {
          return languages[key]
        })
        .find(function (data) {
          return data.name === language || data.value === language
        })
    }

    function getAllAsArray() {
      return Object.keys(languages).map(function (key) {
        return languages[key]
      })
    }

    function getAllValues() {
      return Object.keys(languages).map(function (data) {
        return data.value
      })
    }

    function loadAgentLanguages() {
      return languageApiConfig.getLanguages().then(function (response) {
        return response.data.agentLanguages
      })
    }
  }
})()
